import { IconBase, IconComponent } from './BaseIcon';

export const ExternalLink: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M22.63 28H4V9.37h12v-2H2V30h22.63V16h-2v12zM16 2v2h10.6L12.63 17.96l1.42 1.42L28 5.42V16h2V2H16z" />
  </IconBase>
);
